import Barcoder from 'barcoder';
import React from 'react';
import { Page, Text, View, Document, StyleSheet, Font, Image } from '@react-pdf/renderer';

import logo from '../../../../assets/logo.png';
import { useTranslation } from 'react-i18next';
import formatDate from '../../../../helpers/formatDate';

const maxProductLength = 80;


const OrderLineHeader = () => {
 return  <View style={tableStyles.headerRow}>
        <Text style={tableStyles.description}>Description</Text>
        <Text style={tableStyles.qty}>Qty x P.U.</Text>
    </View>
}


const OrderLineFooter = ({orderLines}) => {
    const {t } = useTranslation(undefined,{ useSuspense: false });

  const eligibleItems = orderLines.filter(t => !t.deleted && t.quantity > 0);
  const nbOfProducts = eligibleItems.length;
  const nbOfArticles = eligibleItems.reduce((acc,curr) => acc+curr.quantity,0);
  const countAmount = eligibleItems.reduce((acc,curr) => acc+(curr.quantity*curr.unitPrice),0)*0.01;
 return  <View style={tableStyles.footerRow}>
        <Text style={tableStyles.description}>{t("order.pdf.product_count",{count:nbOfProducts})} / {t("order.pdf.article_count",{count:nbOfArticles})} </Text>
        <Text style={tableStyles.qty}>{countAmount}</Text>
    </View>
}


const OrderLineTable= ({orderLines}) => {
  return (<View style={tableStyles.container}>
   <OrderLineHeader/>
   {orderLines.filter(t => !t.deleted && t.quantity > 0).map(t => (<OrderLine oi={t}/>))}
   <OrderLineFooter orderLines={orderLines}/>
  </View>)
  
}



const OrderLine = ({oi}) => {
    const {t,ready } = useTranslation(undefined,{ useSuspense: false });

  const productLabel = oi.name.slice(0,maxProductLength - 5);
  const quantity = oi.quantity.toString();
  const unitPrice = (oi.unitPrice * 0.01).toFixed(2);
  const productBarcode = oi.object?.barcode;
  const tags = [
		...(oi.pickingMethod === "SCAN" ? [t('order.pickup.scanned_label')] : []),
    	...(Barcoder.validate(productBarcode) ? [productBarcode] : []),
		...(oi.fulfillmentIssue ? [t(`order.fulfillment_issue.${oi.fulfillmentIssue}`)] : []),
	].join(" / ");
  
  return  <>
  	<View style={tableStyles.row}>
        <Text style={tableStyles.description}>{productLabel}</Text>
        <Text style={tableStyles.qty}>{quantity} x {unitPrice}</Text>
    </View>
  	{<View style={tableStyles.rowInner}>
        <Text style={tableStyles.description}>{tags}</Text>
        <Text style={tableStyles.qty}></Text>
    </View>
    }  
  </>
}

const OrderDateInfo = ({order}) => {

    const {t,ready } = useTranslation(undefined,{ useSuspense: false });
    return (<View style={styles.orderDates}>
        <Text style={[styles.itemInfo,{fontWeight:'bold'}]}>{`${order.platform.name} - ${order.displayId}`}</Text>
        <Text style={styles.itemInfo}>{t('order.received_at_date',{dt:formatDate(order.receivedAt)})}</Text>
        <Text style={styles.itemInfo}>{t('order.accepted_at_date',{dt:formatDate(order.acceptedAt)})}</Text>
        <Text style={styles.itemInfo}>{t('order.completed_at_date',{dt:formatDate(order.completedAt)})}</Text>
    </View>)
}

export const OrderPdfDocument = ({order}) => (
  <Document>
    <Page style={styles.body}>
        <Image style={{width: 50, position:'absolute', top:15,left:15}} src={logo} fixed />
       <Text style={styles.header1} render={({ pageNumber, totalPages }) => (
        `Ticket ${order.id} - ${pageNumber} / ${totalPages}`
      )} fixed />
       <Text style={styles.header2} fixed>
       {order.platform.name} - {order.displayId}
       </Text>
     
      <OrderLineTable orderLines={order.orderItems}/>

      <OrderDateInfo order={order} />
      
    </Page>
  </Document>
);

const rowRaw = {
        flexDirection: 'row',
        alignItems: 'center',
        height: 24
    };

const headerRow= {
  ...rowRaw,
  fontWeight: 'bold',
};

const tableStyles = StyleSheet.create({
  	container: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        alignItems: 'center',
      	fontSize:12,
      	justifyContent:'center'
    },
    headerRow: {
       ...headerRow,
      borderBottom: '1px solid #111111'
    },
  	footerRow: {
      ...headerRow,
      borderTop: '1px solid black'
    },
    row: {
        ...rowRaw
    },
    rowInner: {
        flexDirection: 'row',
        alignItems: 'top',
        textAlign: 'left',
        height: 16,
      	fontSize:8,
      	marginLeft:10
    },
    description: {
        width: '60%',
        textAlign: 'left',
    },
    qty: {
        width: '40%',
        textAlign: 'right',
    },
   
  });


const header = {
    fontSize: 12,
    textAlign: 'center',
}


// Create styles
const styles = StyleSheet.create({
    body: {
        paddingTop: 35,
        paddingBottom: 65,
        paddingHorizontal: 35,
        lineHeight: 0,
        flexDirection: 'column'
      },
      
  header1: {
   ...header,
    fontSize: 8
  },
  header2: {
    ...header,
    marginBottom: 20,
  },
  orderDates:{
    marginTop: 10,
    fontSize: 12,
    flexDirection: 'column',
    alignItems: 'right',
    textAlign: 'right',
  }
});
  
  